import Panel from './Panel';
export { Props } from './Panel';
export default Panel;
